import { PAGE_TYPE, setAppPage } from "../../features/base/app";
import { conferenceJoined, conferenceWillJoin, getGroupId, getMainRoomRole, getMateRoom, setMainRole } from "../../features/base/conference";
import { getLocalUserUUID, isCheckPermission, setLocalUserProperty } from "../../features/base/localuser";
import { setAudioMuted, setVideoMuted } from "../../features/base/media";
import {
    assignGroupParticipant,
    checkGroupPermission, deletePinParticipant, getLocalParticipant, getLocalParticipantId,
    getParticipantById, getParticipantDisplayName, getUserIDByMemberId,
    participantJoined, participantLeft, participantRoleChanged,
    participantsJoin,
    PARTICIPANT_STATUS, PERMISSION, pinParticipant, ROLE, setBridgeParticipant, setGroupParticipant, setRecordingParticipant, unsetGroupParticipant
} from "../../features/base/participants";
import { getDisplayName } from "../../features/base/settings";
import { delVodList, setFocusVod, setVodItem, setVodList, VOD_FILE, VOD_URL } from "../../features/base/vod";
import { addMessage, clearMessages, endpointMessageReceived } from "../../features/chat";
import { getGroupIdByUserID, getStartGroup, getStartGroupList, initGroupList, setGroupStatus, setGroupUpdate } from "../../features/group";
import { NOTIFICATION_TIMEOUT, removeParticipantNotification, showNotification, showRequestPresentation, showStartAttendance } from "../../features/notifications";
import { SURVEY_MODAL_ID } from "../../features/options";
import { getScreenVideoShared, setScreenVideoShareState } from "../../features/screen-share";
import { DEFAULT_DOCUMENT, getFilterDocumentListByUuid, removeDocumentFile, setCanvasLine, setCanvasOneLine, setDeleteKeyLine, setDeleteLine, setDeleteOneLine, setDocumentFile, setDocumentSharedFile, setFocusShareDocument } from "../../features/share-document";
import { addSharedSurvey, isExistSurvey, setSurveyReplied } from "../../features/survey";
import { checkLayoutMode, getCurrentMode, getPreviewMode, setVideoLayoutMode, setVideoLayoutProperty, videoLayoutMode } from "../../features/video-layout-mode";
import messageHandler from "../../modules/UI/util/MessageHandler";
import { createTaskQueue } from "../../modules/util/helpers";
import { command } from "./comand";

function getState() {
    return APP.store.getState();
}

export default function MateConference(mate) {
    this.mate = mate;
    this.layoutMode = null;

    this.dispatch = null;
}

const task = createTaskQueue();
MateConference.prototype.constructor = MateConference;

MateConference.prototype.init = function() {
    const { dispatch } = APP.store;
    
    this.dispatch = dispatch;
}
// websocket auth 
MateConference.prototype.setAuth = function(group_id = "") {
    const meeting_uuid = APP.mateManagement.getMeetingId();

    this.dispatch(conferenceWillJoin(meeting_uuid, this.mate.type));
    
    this.mate.events.join();

    group_id === "" && APP.mateManagement.mediaServerConnection();
}

// 참석자 퇴장 (local 제외)
MateConference.prototype.participantLeave = function({ from }, group_id = "") {

    const user_uuid = getUserIDByMemberId(getState(), from);
    const participant = getParticipantById(getState(), user_uuid);

    participant && this.dispatch(participantLeft(participant, group_id));
}
// 참석자 입장 (local 제외)
MateConference.prototype.participantJoined = async function({ message: data }, groupId = "") {
    const currentGropuId = getGroupId(getState());

    const participant = { ...data, local: false, status: PARTICIPANT_STATUS.OCCUPIDE, entryTime: Date.now(), existed: true };

    
    if (groupId === currentGropuId) {
        this.dispatch(participantJoined(participant, false, groupId));        
        if (data.pinned) this.dispatch(pinParticipant(data.user_uuid));
    } 
}

// 참석자 bridge_session_id 추가 
MateConference.prototype.setJitsiId = function({ message: data }) {
    const jitsi_id = data.bridge_session_id;
    const user_id = data.user_id;

    this.dispatch(setBridgeParticipant(user_id, jitsi_id));
}

/**
 * 채팅
 */
MateConference.prototype.sendMessage = function({ from, message: data }) {
    const local = getLocalParticipant(getState());
    const isMe = local && local.member_uuid === from;

    const parseMessage = JSON.parse(data);
    
    if (parseMessage.type === 'text' || parseMessage.type === 'file') {
        const { isOpen: isChatOpen } = getState()['features/chat'];
        this.dispatch(addMessage({
            isMe,
            hasRead: isMe || isChatOpen,
            from,
            message: data,
            privateMessage: false,
            timestamp: parseMessage.time
        }));
        return;
    }

    if (!isMe) {
        this.dispatch(endpointMessageReceived(from, parseMessage));
    }
}
/**
 * 문서
 */
// 문서 공유 상태 
MateConference.prototype.statusChanged = function({ uuid, resource_id, status: documentStatus, completed_pages }) {
    if (documentStatus === 'completed') {
        let document_list = getFilterDocumentListByUuid(getState(), uuid, false);
        if (document_list) { 
            document_list = {
                ...document_list,
                complete: true,
                page: resource_id,
                count: completed_pages.length,
                list: completed_pages,
            };

            this.dispatch(setDocumentSharedFile(document_list));
        }
    }  else if (documentStatus === 'failed') {
        let document_list = getFilterDocumentListByUuid(getState(), uuid, false);
        if (document_list) { 
            alert("문서 변환중 오류가 발생했습니다. 다시 시도해주세요.");
            this.dispatch(removeDocumentFile(uuid, false));
        }
    }
}
// 문서 저장
MateConference.prototype.setDocument = function({ document }) {
    if (document) {
        const mode = document.isWhiteBoard ? videoLayoutMode.white : videoLayoutMode.document;
        const list = getFilterDocumentListByUuid(getState(), document.uuid, mode);

        setShareDocumentList(document);  
    }
}
// 문서 삭제
MateConference.prototype.delDocument = function({ uuid }) {
    const isWhiteBoard = uuid.indexOf(DEFAULT_DOCUMENT) !== -1 ? true : false;

    this.dispatch(removeDocumentFile(uuid, isWhiteBoard));
}
// 문서 캔버스 저장
MateConference.prototype.setCanvas = function({ key, value, uuid, index }) {
    const newLine = new Map([[key, value]]);            
    this.dispatch(setCanvasOneLine(newLine, uuid, index));
}
// 문서 캔버스 삭제 
MateConference.prototype.delCanvas = function({ key, value, uuid, index, isAll }) {
    if (isAll) {
        if (key) this.dispatch(setDeleteKeyLine(key, uuid, index));
        else this.dispatch(setDeleteLine(uuid, index));
    } else {
        if (key) this.dispatch(setDeleteOneLine(key, uuid, index));
    }
}

// 녹화 
MateConference.prototype.setRecording = function({ to, recording }) {
    const user_uuid = getUserIDByMemberId(getState(), to);
    _handlerSetParticipant('record', recording, user_uuid);
}

/**
 * 발표권
 */
// 발표자 요청
MateConference.prototype.requestPresentation = function({ from }) {
    const local = getLocalParticipant(getState());
    if (local && local.role === ROLE.HOST) {
        const user_uuid = getUserIDByMemberId(getState(), from);
        this.dispatch(showRequestPresentation(user_uuid));
    }
}
// 발표자 응답
MateConference.prototype.responsePresentation = function({ to, accepted }) {

    const participant = getLocalParticipant(getState());
    
    if (to === participant.member_uuid) {
        this.dispatch(showNotification({ titleKey: `notify.${accepted}ResponsePresenter`}, NOTIFICATION_TIMEOUT));
    } 

    if (participant && participant.role === ROLE.HOST) {
        this.dispatch(removeParticipantNotification(to));
    }
}

/**
 * 그룹
 */
// 그룹 생성 및 삭제 
MateConference.prototype.setGroup = function() {
    initGroup();
}

// 그룹 시작 
MateConference.prototype.startGroup = function({ group_id }) {
    initGroup()
        .then(async response => {
            // console.log("회의실 시작 되었습니다. : ", response);
            if (response) {
                const localID = getLocalUserUUID(getState());
                const main_role = getMainRoomRole(getState());
                
                if (checkGroupPermission(main_role) === false) {
                    const group = response.participant.get(localID);

                    // 할당된 그룹 시작
                    if (group && group_id === group.group_id) {
                        APP.mateManagement.startGroupMeeting(group_id, true);
                    }
                }
                this.dispatch(setGroupUpdate(new Date()));
            }
        })
}


MateConference.prototype.endGroup = function({ group_id }) {
    initGroup()
        .then(response => {
            if (response) {
                const localID = getLocalUserUUID(getState());  
                const main_role = getMainRoomRole(getState());
                
                if (checkGroupPermission(main_role) === false) {  
                    const group = response.participant.get(localID);

                    // 할당된 그룹 종료
                    if (group && group_id === group.group_id) {
                        APP.mateManagement.changeMeetingRoom("");
                    }
                }

                this.dispatch(setGroupUpdate(new Date()));
            }
        });
}

MateConference.prototype.assginGroup = function({ group_id, meeting_id, role_name, user_id }) {
    // 할당
    this.dispatch(assignGroupParticipant({group_id, user_id, role_name}));

    const groupStart = getStartGroup(getState());
    if (groupStart) {  
        const localID = getLocalUserUUID(getState());
        if (user_id === localID) {
            const main_role = getMainRoomRole(getState());
        
            if (checkGroupPermission(main_role) === false) {
                // 현재 할당된 그룹이 오픈 되어있는지 확인 
                const startList = getStartGroupList(getState());
                if (startList.indexOf(group_id) !== -1) {
                    APP.mateManagement.changeMeetingRoom(group_id);
                } else {
                    APP.mateManagement.changeMeetingRoom("");
                }
            }
        }
    }
    this.dispatch(setGroupUpdate(new Date()));  
};

// 그룹 할당 해제
MateConference.prototype.unsetGroup = function({ group_id, meeting_id, role_name, user_id }) {
    this.dispatch(unsetGroupParticipant({ group_id, user_id }));
    
    const groupStart = getStartGroup(getState());
    if (groupStart) {
        const localID = getLocalUserUUID(getState());
    
        if (user_id === localID) {
            const main_role = getMainRoomRole(getState());
                            
            if (checkGroupPermission(main_role) === false) {
                // const group = getAllGroupStatus(getState()).get(localID)                
                // const startList = getStartGroupList(getState());

                APP.mateManagement.changeMeetingRoom("");
            }
        }   
    }
    this.dispatch(setGroupUpdate(new Date()));  
};

MateConference.prototype.setGroupStatus = function({ running }) {
    initGroup().then(response => {
        if (response) {
            if (!running) {
                this.dispatch(setGroupStatus(false));  
            } else {
                this.dispatch(setGroupStatus(true));  
            }

            this.dispatch(setGroupUpdate(new Date()));
        }
    });
}

/**
 * 메시지 전달
 */
MateConference.prototype.getNotification = function({ message, group_id }) {
    const currentGroupId = getGroupId(getState());
    if (currentGroupId === group_id) {
        this.dispatch(showNotification({titleKey: 'notify.notifyMessage', description: message}, NOTIFICATION_TIMEOUT));
    }
}


/**
 * 사용자
 */
// 참석자 role 변경
MateConference.prototype.setParticipantRole = function({ message: data }, groupId = "") {
    var { target, role, permissions } = data;
    this.dispatch(participantRoleChanged(target, role));
    
    const memberLocalId = getLocalParticipantId(getState());
    if (target === memberLocalId) {
        if (groupId === "") this.dispatch(setMainRole(role));
        this.dispatch(setLocalUserProperty({ permissions, role }));
    }

    // set role 
}
// 강퇴
MateConference.prototype.kickMemeber = function({ to, from }) {
    const localMemberID = getLocalParticipant(getState()).member_uuid;

    let displayName;
    if (to === localMemberID) {
        if (from !== to) {
            const user_uuid = getUserIDByMemberId(getState(), from);
            displayName = getParticipantDisplayName(getState(), user_uuid);
        }
        APP.mateManagement.disconnect();
        this.dispatch(setAppPage(PAGE_TYPE.LOBBY));      
        if (from !== to) {
            messageHandler.alertMeesgae('notify.kickParticipant', { displayName });
        } else {            
            messageHandler.alertMeesgae('notify.dupLogin');
        }  
    }
}
// 카메라 
MateConference.prototype.setVideoMuted = function(muted) {
    this.dispatch(setVideoMuted(muted));
}
// 마이크 
MateConference.prototype.setAudioMuted = function(muted) {
    this.dispatch(setAudioMuted(muted));
}

/**
 * VOD
 */
// vod 등록
MateConference.prototype.setVodList = function({ video_uuid }) {
    this.dispatch(setVodItem(video_uuid, true));
}
// vod 삭제
MateConference.prototype.deleteVodItem = function({ video }) {
    this.dispatch(delVodList(video));
}
// focus vod
MateConference.prototype.selectVodItem = function({ video_uuid }) {
    this.dispatch(setFocusVod(video_uuid, true));
}

/**
 * 설문 조사 
 */
// 설문 조사 알림
MateConference.prototype.notifySurvey = async function({ survey_id }) {
    if (isExistSurvey(getState(), survey_id)) return;
    var { complete, message } = await APP.API.getSurveyInfo(survey_id);

    if (complete) {
        this.dispatch(addSharedSurvey(survey_id, message));
        if (getState()['features/base/modal'].name !== SURVEY_MODAL_ID) {
            APP.UI.openModal(SURVEY_MODAL_ID);
        }
    }
}
// 설문 조사 응답
MateConference.prototype.replySurvey = function({ survey_id }) {
    const user_uuid = getUserIDByMemberId(state, from);
    this.dispatch(setSurveyReplied(survey_id, user_uuid));
}

/**
 * 출석 확인
 */
MateConference.prototype.startAttendance = function({ name, uuid, check_duration }) {
    this.dispatch(showStartAttendance({ name, uuid, check_duration }));
}

/**
 * 레이아웃 
 */
// 화면 설정
MateConference.prototype.setLayoutViewVisible = function({ view_visible }) {
    const mode = getCurrentMode(getState());
    const prevMode = getPreviewMode(getState());
    const changeMode = checkLayoutMode(prevMode, view_visible);

    this.dispatch(setVideoLayoutMode(changeMode, true));
    this.layoutMode = changeMode;
}
// 레이아웃 모드
MateConference.prototype.setLayoutMode = function(commandName) {
    let mode = videoLayoutMode.grid;
    if (commandName === `Event.${command[videoLayoutMode.pin]}`) mode = videoLayoutMode.pin;
    else if (commandName === `Event.${command[videoLayoutMode.voice]}`) mode = videoLayoutMode.voice;
    else if (commandName === `Event.${command[videoLayoutMode.seminar]}`) mode = videoLayoutMode.seminar;

    this.dispatch(setVideoLayoutMode(mode, true));
}
// 그리드 모드 option 
MateConference.prototype.setGridOption = function({ grid_count }) {
    this.dispatch(setVideoLayoutProperty({ gridCount: grid_count }));
}
// 핀 모드 option 
MateConference.prototype.setPinOption = function({ message: data }, pinned) {
    _handlerSetParticipant('pin', pinned, data.target);
}
// 화면 공유 모드 option 
MateConference.prototype.setScreenOption = function({ target: member_uuid, jitsi_id }) {
    const currentSharing = getScreenVideoShared(getState());

    if ( APP.mateManagement.getScreenSharing() && !jitsi_id ) {
        APP.mateManagement.toggleScreenShare(false); // close share screen
        return;
    }

    this.dispatch(setScreenVideoShareState({ member_uuid, track_id: jitsi_id }));
}
// focus item - document
MateConference.prototype.setFocusDocument = function({ uuid, index }, isWhiteBoard) {  
    this.dispatch(setFocusShareDocument(uuid, index, isWhiteBoard, true));
}

// local 사용자 입장
MateConference.prototype.join = async function(data) {
    const meeting_uuid = APP.mateManagement.getMeetingId();
    const { 
        member_uuid, layout, view_visible, grid_count, role, permissions, pinned, members, document_list, video_list, group_id, 
        last_notification
    } = data;

    this.dispatch(clearMessages());

    await initGroup();
    
    
    // 메인 룸 + 그룹 룸 (현재 방)
    const participant = getLocalParticipant(getState());
    const user_uuid = participant?.user_uuid || getLocalUserUUID(getState());
    const localParticipant = {
        user_uuid,
        member_uuid,
        ...participant,
        status: PARTICIPANT_STATUS.OCCUPIDE,
        group_id,
        member_uuid,
        role: role,
        permissions: permissions,
        local: true,
        nickname: getDisplayName(getState()),
        hidden: false,
        pinned
    };

    // 로컬 사용자 입장
    this.dispatch(participantJoined(localParticipant, true, group_id));   
    
    // remote 사용자 입장 
    this.dispatch(participantsJoin(members, group_id));     
    // init Room
    // this.dispatch(initRoom(data, user_uuid));
    if (pinned) this.dispatch(pinParticipant(user_uuid));
    this.dispatch(setLocalUserProperty({ permissions, role }));

    this.dispatch(setVideoLayoutMode(layout, true));
    this.dispatch(setVideoLayoutProperty({
        viewVisible: view_visible
    }));

    // grid
    if (layout === videoLayoutMode.grid) {
        grid_count && this.dispatch(setVideoLayoutProperty({
            gridCount: grid_count
        }));
    }

    if (view_visible[videoLayoutMode.screen]) {
        const screenUserId = data.screen_shared_member_uuid;
        const track_id = data.screen_shared_jitsi_id;

        this.dispatch(setScreenVideoShareState(screenUserId ? { member_uuid: screenUserId, track_id } : false));
    }
    // vod
    if (view_visible[videoLayoutMode.vod]) {
        const vodId = data?.vod_shared_video_uuid;

        // vodId && dispatch();
    }

    if (video_list) {
        video_list[VOD_FILE] && video_list[VOD_FILE].map(item =>  this.dispatch(setVodItem({ ...item, type: VOD_FILE })));
        video_list[VOD_URL] && video_list[VOD_URL].map(item =>  this.dispatch(setVodItem({ ...item, type: VOD_URL })));
    }
    
    // document_list
    if (document_list) {     
        document_list.map(value => {
            setShareDocumentList(value);
        });
    }

    if (data.vod_shared_video_uuid) {            
        this.dispatch(setFocusVod(data.vod_shared_video_uuid, true));
    }
    // share document 
    if (data.document_focus_item) {
        const { uuid, index } = data.document_focus_item;
        
        this.dispatch(setFocusShareDocument(uuid, index, false));
    }
    
    if (data.whiteboard_focus_item) {
        const { uuid, index } = data.whiteboard_focus_item;

        this.dispatch(setFocusShareDocument(uuid, index, true));
    }

    if (last_notification !== "") {
        this.dispatch(showNotification({titleKey: 'notify.notifyMessage', description: last_notification}, NOTIFICATION_TIMEOUT));
    }

    // 이전 설문 조사 등록
    getSurveyList(meeting_uuid);

    // room join  
    const groupStart = getStartGroup(getState());
    const assignGroup = getGroupIdByUserID(getState(), user_uuid)?.group_id;

    // 처음 join 할때 그룹 이동 
    const mateJoined = getMateRoom(getState())?.joined;
    if (group_id === "" && mateJoined !== true) {
        // 만약 하나의 그룹이라도 실행 중인 경우 
        if (groupStart) {
            // 권한자인 경우 
            if (checkGroupPermission(role)) {
                if (assignGroup) {
                    // 할당 해제 
                    await APP.API.assignGroup({ members: [{ user_id: user_uuid, role_name: role }], method: "unset" }, assignGroup);

                    this.dispatch(conferenceJoined({
                        conference: meeting_uuid,
                        joined: undefined,
                        leaving: undefined
                    }, "mate"));
                    return;
                } 
            } else {
                // 권한자가 아닌 경우 
                if (assignGroup !== "") {
                    const startList = getStartGroupList(APP.store.getState());

                    if (startList.indexOf(assignGroup) === -1) {
                        this.dispatch(conferenceJoined({
                            conference: meeting_uuid,
                            joined: undefined,
                            leaving: undefined
                        }, "mate"));
                        return;
                    }

                    APP.mateManagement.startGroupMeeting(assignGroup, true);
                }
            } 
        }
    } 

    if (mateJoined !== true) {
        if (groupStart === true) {
            if (assignGroup === group_id) {
                this.dispatch(conferenceJoined({
                    conference: meeting_uuid,
                    joined: undefined,
                    leaving: undefined
                }, "mate"));
            }
            if (!assignGroup) {
                this.dispatch(conferenceJoined({
                    conference: meeting_uuid,
                    joined: undefined,
                    leaving: undefined
                }, "mate"));
            }
        } else {
            this.dispatch(conferenceJoined({
                conference: meeting_uuid,
                joined: undefined,
                leaving: undefined
            }, "mate"));
        }        
    }    
}

export function setShareDocumentList(value) {
    const { dispatch, getState } = APP.store;
    
    const sharedPremission = isCheckPermission(getState(), PERMISSION.SHARE);
    const participant = getLocalParticipant(getState());
    if (value.shared || (sharedPremission && value.member_uuid === participant.member_uuid) || value.uuid === DEFAULT_DOCUMENT) {
        if (value.canvasList) {
            const list = parseCanvaseLine(value.canvasList);
            dispatch(setCanvasLine(list, value.uuid));
        }   
        
        dispatch(setDocumentFile({ ...value }));
    }   
}

function parseCanvaseLine(canvasList) {
    let list = new Map();
    canvasList && Object.keys(canvasList).forEach(index => {
        list = {
            ...list,
            [index]: new Map(Object.entries(canvasList[index]))
        }
    });
    
    return list === undefined ? new Map() : new Map(Object.entries(list));
}

function _handlerSetParticipant(type, action, user_uuid) {
    const { dispatch, getState } = APP.store;
    
    // const participant = getParticipantById(getState(), user_uuid);
    // if (!participant) return;

    if (type === 'pin') {
        if (action) dispatch(pinParticipant(user_uuid));
        else dispatch(deletePinParticipant(user_uuid));
    } else if (type === 'record') {
        dispatch(setRecordingParticipant(user_uuid, action));
    }
}

// 설문 조사
async function getSurveyList(meeting_uuid) {
    const { dispatch } = APP.store;

    var { complete, message } = await APP.API.getAllSurvey(meeting_uuid);
    if (complete) {
        if (message === null) return;
        message.map(value => {
            if (!value.uuid) return;
            const deadline = value.info.deadline;
            if ( deadline && Date.parse(deadline) < Date.parse(new Date())) {
                if (Array.isArray(value.info.replied) ) {
                    value.info.replied = new Set(value.info.replied);
                }

                if ( !value.info.replied.has(user_uuid) && role !== ROLE.HOST ) return;
            }
            dispatch(addSharedSurvey(value.uuid, value.info));
        });
    }
}

export function initGroup () {
    return new Promise(function(resolve, reject) {
        APP.API.getGroupList()
            .then(response => {
                if (response.complete) {
                    let items = new Map();
                    let data = new Array();
                    const groups = response.message;

                    Object.keys(groups).map(uuid => {
                        const group = groups[uuid];
            
                        const list = {
                            ...group, 
                            uuid,
                            name: group.name
                        };
            
                        data.push(list);

                        group.members && group.members.map(m => {
                            items.set(m.user_id, { ...m, group_id: uuid });
                        });  
                    });

                    APP.store.dispatch(initGroupList(data));
                    APP.store.dispatch(setGroupParticipant(items));

                    resolve({ participant: items });
                }
                resolve(false);
            }).catch(err => {
                console.log(err);
                resolve(false);
            });
    });
}